import {Container, Stack, Typography} from "@mui/material";
import React from "react";
import Pjdb1Button from "../../../../components/inputs/Pjdb1Button";
import {useReset} from "../../contexts/OperatingTestContext";

export default function StepError() {
  const reset = useReset();

  return (
    <Container
      sx={{px: 0, py: 2, display: "flex", flexDirection: "row", flexWrap: "wrap"}}
      maxWidth={false}
    >
      <Stack gap={1}>
        <Typography variant='h6' component='h2'>問題が発生しました</Typography>
        <Pjdb1Button
          label='始めからやり直す'
          onClick={() => {
            reset();
          }}
          variant='contained'
          color='inherit'
        />
      </Stack>
    </Container>);
}
